<template>
    <div class="session-tracker">
        <div class="session-icon">
        </div>
        <div class="session-body">
            <div class="session-progress">
                <div class="session-bar">
                    <div class="progress-section" :class="{ active: panelState.curPanel >= x }" v-for="x in panelState.panels.length - 1" :key="x" :id="panelState.panels[x]">
                        {{x}}
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        created: function() {
            var self = this;
        },
        data: function() {
            return {
                progress: 0
            }
        },
        props: ["panelState"],
        computed: {
        }
    }
</script>
<style lang="stylus">
.session-tracker
    color: #fff
    display: flex
    width: 430px
    margin: 2em auto
    .session-body
        flex: 1
        display: flex
        flex-direction: column
        text-align: left
        padding: 0 1em
        justify-content: center
        .session-text
            // opacity: 0.75
            line-height: 1em
        .session-progress
            display: flex
            align-items: center
            margin-top: 8px
            .session-bar
                flex: 1
                .progress-section
                    position: relative
                    background: rgba(226,226,226, 0.8)
                    height: 18px
                    width: 10%
                    overflow: hidden
                    display: inline-block
                    font-weight: bold
                    text-align: center
                    &.active
                        top: 0
                        bottom: 0
                        left: 0
                        background: #28c5cc
                        // width: 50%
                        border-radius: 0
                    &#Challenges
                        border-radius: 3em 0 0 3em
                    &#Conclusion
                        border-radius: 0 3em 3em 0
</style>